import React from 'react';
import { connect } from 'react-redux';

import {
  getSellerAvatar,
  getSellerUsername,
  getIsStoreEnabled,
  getSellerFullName,
  getIsCartEnabled,
} from '../../reducers/ProductReducers';

import {
  getStoreLink,
} from '../../utils/ProductUtils';

const SellerInfoComponent = ({ avatar, sellerFullName }) => {
  return (
    <span>
      <img
        src={avatar}
        style={{ height: '20px', borderRadius: '2px', display: 'inline-block' }}
      />
      <span
        style={{ verticalAlign: 'middle' }}
        className="caps strong soft-half--left seller-name store__link"
      >
      {sellerFullName}
      </span>
    </span>
  );
};

const SellerInfo = ({
  avatar,
  username,
  isStoreEnabled,
  isCartEnabled,
  sellerFullName,
  refTag,
}) => {
  if (!isStoreEnabled) {
    return <SellerInfoComponent avatar={avatar} sellerFullName={sellerFullName} />;
  }

  return (
    <a href={getStoreLink(username, refTag)} target={isCartEnabled ? '' : '_blank'}>
      <SellerInfoComponent avatar={avatar} sellerFullName={sellerFullName} />
    </a>
  );
};

const mapStateToProps = ({ product }) => ({
  avatar: getSellerAvatar(product),
  username: getSellerUsername(product),
  isStoreEnabled: getIsStoreEnabled(product),
  isCartEnabled: getIsCartEnabled(product),
  sellerFullName: getSellerFullName(product),
});

export default connect(mapStateToProps)(SellerInfo);



// WEBPACK FOOTER //
// ./src/product/views/_layout/SellerInfo.js